import { Alert } from "@material-ui/lab";
import React from "react";
import { useState } from "react";
import { useMutation } from "react-query";
import GovGrButton from "../../../../components/GovGrButton";
import {
  checkEParavoloAVathmias,
  checkEParavoloBVathmias,
  STATUS_DESMEUMENO_PARAVOLO,
} from "../../../../constants";
import useLocale from "../../../../hooks/useLocale";
import { useParavolo } from "../../../../services/eParavolo";
import { getParavoloByStatusBackOffice } from "../../../../utils/errorMessage";
import CustomAlert from "../../../components/CustomAlert";

const EParavoloBackOffice = ({ data, refetch }) => {
  const { t } = useLocale();
  const [error, setError] = useState("");

  // Gets the paravolo based on status and displays it to backoffice user

  const paravoloData = getParavoloByStatusBackOffice(data);

  const { mutate } = useMutation(useParavolo, {
    onSuccess: (data) => {
      refetch();
    },
    onError: (err) => {
      if (err.response.status === 409) {
        setError(err.response.data);
      }
    },
  });

  const dataToSendToUseparavolo = {
    application_id: data?.id,
    paravoloPaymentCode: paravoloData?.paravolo_payment_code,
    userAfm: data?.afm_afora,
    application_status_id: data?.status,
  };
  const handleSubmitParavolo = () => {
    mutate(dataToSendToUseparavolo);
  };

  const paravoloStatus =
    data?.status === checkEParavoloAVathmias ||
    data?.status === checkEParavoloBVathmias;

  return (
    <>
      {paravoloStatus ? (
        <div className="h-[40vh] flex flex-col gap-6 justify-center items-center">
          <CustomAlert
            open={!!error}
            close={() => {
              setError("");
            }}
            message={t(error)}
          />
          {/* <CustomAlert
        open={!!error}
        severity="success"
        close={() => {
          setError("");
        }}
        message={t(error)}
      /> */}
          <div className="flex flex-col items-center gap-4">
            {paravoloData?.paravolo_status_id === STATUS_DESMEUMENO_PARAVOLO ? (
              <h2 className="text-lg font-bold text-success">
                {t("eParavoloBound")}
              </h2>
            ) : (
              <h2 className="text-lg font-bold text-error">
                {t("eParavolo_Use_BackOffice")}
              </h2>
            )}
            <h3 className="text-base font-bold">
              {t("eParavoloPaymentCreated")}:
              {paravoloData?.paravolo_payment_code}
            </h3>
            <h4 className="text-base font-bold">
              {t("Paravolo RF Code")}:{paravoloData?.paravolo_rf_code}
            </h4>
            <GovGrButton
              buttonText={t("useParavoloText")}
              onClick={handleSubmitParavolo}
              disabled={
                paravoloData?.paravolo_status_id === STATUS_DESMEUMENO_PARAVOLO
              }
            />
          </div>
        </div>
      ) : (
        <Alert severity="error" style={{ marginBottom: "1rem" }}>
          {t("Application_not_status_eParavolo_backOffice")}
        </Alert>
      )}
    </>
  );
};

export default EParavoloBackOffice;
